import { useEffect, useState } from "react";
import { fetchMemberAudienceStats } from "../../../api/memberAudienceStats";
import { useAdminData } from "../AdminDataContext";
import { memberLevelStore } from "../utils/memberLevelStore";
import { getUserFacingMessage } from "../../../api/errors";
import {
  buildMemberAudienceUiCounts,
  type MemberAudienceUiCounts,
} from "../utils/memberAudienceStatsUi";

export function useMemberAudienceUi(): {
  audience: MemberAudienceUiCounts | null;
  loading: boolean;
  error: string | null;
} {
  const { tenantLegacyId, storeVersion } = useAdminData();
  const [audience, setAudience] = useState<MemberAudienceUiCounts | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!tenantLegacyId) {
      setAudience(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    void fetchMemberAudienceStats(tenantLegacyId)
      .then((api) => {
        if (cancelled) return;
        const sorted = [...memberLevelStore.getAll()].sort((a, b) => a.sortOrder - b.sortOrder).map((l) => l.name);
        setAudience(buildMemberAudienceUiCounts(api, sorted));
      })
      .catch((e) => {
        if (cancelled) return;
        setAudience(null);
        setError(getUserFacingMessage(e, "受众数据加载失败，请重试。"));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tenantLegacyId, storeVersion]);

  return { audience, loading, error };
}
